<template>

<app-page :title="($isAdmin) ? 'Data Users' : 'Users'" back="Dashboard" :is-loading="is.loading">

    <app-panel :title="($isAdmin) ? 'Data Users' : 'Users'" :is-loading="is.loading" :is-empty="is.empty">

        <app-table>
            <thead>
                <tr>
                    <th width="100">Type</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th width="200">Hospitals</th>
                    <th width="60"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in collection" :key="item.id">
                    <td>{{ $constants.userTypeTextShort[item.type] }}</td>
                    <td>{{ item.firstname }} {{ item.lastname }}</td>
                    <td>{{ item.email }}</td>
                    <td>{{ item.hospitals }}</td>
                    <td><app-button text="View" route="User" :id="item.id" /></td>
                </tr>   
            </tbody>
        </app-table>

    </app-panel>

    <app-actions>

        <app-button text="Add User" route="User" id="create" />

    </app-actions>

</app-page>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

    mixins: [mixCollection],

    data: function() {
    
        return {
            api: 'users'
        }
    
    }

}

</script>

<style scoped>

</style>
